import React from 'react'
import CTA from '../../../components/CTA'
import zuchyImage from '../../../assets/img/zuchy.svg'

const HeroText: React.FC = () => {
  const scrollToAudiobook = () => {
    const audiobookSection = document.getElementById('audiobook-section')
    if (audiobookSection) {
      audiobookSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="w-full md:w-[456px] flex flex-col">
      <h1 className="hidden md:block font-apropal text-[120px] leading-none font-bold">
        ZUCHY
      </h1>
      
      <h2 className="hidden md:block font-urbanist text-[37px] mb-2 text-[#E1DFDF]">
        w poszukiwaniu sensu życia
      </h2>

      <div className="block md:hidden w-full mb-6">
        <img 
          src={zuchyImage} 
          alt="Zuchy book title" 
          className="w-full max-w-full object-contain"
        />
      </div>

      
      <div className="w-full h-[2px] bg-white mb-5"></div>
      
      <p className="font-open-sans text-[16px] mb-8 text-[#E1DFDF] text-left">
        Książka o małych odkrywcach, którzy wyruszają w niezwykłą podróż by znaleźć odpowiedzi na wielkie pytania.
      </p>
      
      <CTA 
        text="Od audiobooka do książki"
        onClick={scrollToAudiobook}
      />
    </div>
  )
}

export default HeroText
